import { useEffect, useState, useCallback } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, BookOpen, TrendingUp, TrendingDown } from "lucide-react";

export default function PublisherReport() {
  const [rows, setRows] = useState([]);
  const [students, setStudents] = useState([]);
  const [sid, setSid] = useState("");
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/reports/publisher-performance", { params: sid ? { student_id: sid } : {} });
      setRows(data);
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setLoading(false);
    }
  }, [sid]);

  useEffect(() => {
    api.get("/students").then((r) => setStudents(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    load();
  }, [load]);

  const maxAvg = Math.max(0, ...rows.map((r) => r.avg_net));

  return (
    <div className="space-y-5" data-testid="publisher-report">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <div className="text-xs font-semibold text-slate-400 flex items-center gap-1.5"><BookOpen size={13} /> Analiz</div>
          <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 mt-1">Yayınevi Bazlı Başarı Raporu</h1>
          <p className="text-slate-500 text-sm mt-1">PPD, Branş Deneme ve Genel Deneme kayıtlarındaki yayınevi bilgisine göre net karşılaştırması.</p>
        </div>
        <select className="ta-input max-w-xs" value={sid} onChange={(e) => setSid(e.target.value)} data-testid="pub-student">
          <option value="">Tüm Öğrenciler</option>
          {students.map((s) => (
            <option key={s.id} value={s.id}>{s.name}{s.track ? ` · ${s.track}` : ""}</option>
          ))}
        </select>
      </div>

      <div className="card-ta overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-slate-200 text-left text-slate-500 bg-slate-50">
                <th className="px-4 py-3 font-medium">Yayınevi</th>
                <th className="px-4 py-3 font-medium text-right">Deneme</th>
                <th className="px-4 py-3 font-medium text-right">D</th>
                <th className="px-4 py-3 font-medium text-right">Y</th>
                <th className="px-4 py-3 font-medium text-right">B</th>
                <th className="px-4 py-3 font-medium text-right">Ort. Net</th>
                <th className="px-4 py-3 font-medium text-right">En İyi</th>
                <th className="px-4 py-3 font-medium text-right">En Düşük</th>
                <th className="px-4 py-3 font-medium w-48">Başarı</th>
              </tr>
            </thead>
            <tbody data-testid="pub-report-table">
              {loading ? (
                <tr>
                  <td colSpan={9} className="px-4 py-10 text-center text-slate-500">
                    <Loader2 className="animate-spin inline" size={20} />
                  </td>
                </tr>
              ) : rows.length === 0 ? (
                <tr>
                  <td colSpan={9} className="px-4 py-10 text-center text-slate-500">
                    Yayınevi girilmiş deneme kaydı yok — PPD / Branş / Genel Deneme girişlerinde "Yayınevi" alanını doldurun.
                  </td>
                </tr>
              ) : (
                rows.map((r) => (
                  <tr key={r.publisher} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`pub-row-${r.publisher}`}>
                    <td className="px-4 py-3 font-semibold text-slate-900">{r.publisher}</td>
                    <td className="px-4 py-3 text-right text-slate-700">{r.count}</td>
                    <td className="px-4 py-3 text-right text-emerald-700 font-semibold">{r.correct}</td>
                    <td className="px-4 py-3 text-right text-rose-700 font-semibold">{r.wrong}</td>
                    <td className="px-4 py-3 text-right text-slate-500">{r.blank}</td>
                    <td className="px-4 py-3 text-right font-mono font-semibold text-indigo-700">{r.avg_net.toFixed(2)}</td>
                    <td className="px-4 py-3 text-right font-mono text-emerald-600">
                      <span className="inline-flex items-center gap-1"><TrendingUp size={13} /> {r.best_net.toFixed(2)}</span>
                    </td>
                    <td className="px-4 py-3 text-right font-mono text-rose-600">
                      <span className="inline-flex items-center gap-1"><TrendingDown size={13} /> {r.worst_net.toFixed(2)}</span>
                    </td>
                    <td className="px-4 py-3">
                      <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
                        <div
                          className="h-full rounded-full bg-gradient-to-r from-emerald-500 to-indigo-500 transition-all"
                          style={{ width: maxAvg ? `${Math.max(6, (r.avg_net / maxAvg) * 100)}%` : "0%" }}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
